import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAPI, postAPI } from "../../service/http-service";
import { DashboardEndpoint } from "../../service/endpointConfig/DashboardEndpoint";

let initialState: any = {
  dashboardResponse: {},
};

//Get Course Instructor API call
export const dashboardAction = createAsyncThunk(
  "dashboard",
  async (dashboardData: any) => {
    try {
      let response;
      switch (dashboardData.apiAction) {
        case "significantImpact":
          response = await getAPI(DashboardEndpoint.significantImpact);
          break;
        case "twoWeekConsecutiveAbsent":
          response = await getAPI(DashboardEndpoint.twoWeekConsecutiveAbsent);
          break;
        case "dashboardBirthDay":
          response = await getAPI(DashboardEndpoint.dashboardBirthDay);
          break;
        case "sendBirthdaySMS":
          response = await getAPI(`${DashboardEndpoint.sendBirthdaySMS}/${dashboardData.id}/${dashboardData.messageType}`);
          break;
        case "popNotDoneStudentList":
          response = await getAPI(DashboardEndpoint.popNotDoneStudentList);
          break;
        case "updatePopDone":
          response = await postAPI(DashboardEndpoint.updatePopDone, dashboardData.payload);
          break;
        case "leadUpdateTracker":
          response = await getAPI(
            `${DashboardEndpoint.leadUpdateTracker}/${dashboardData.month}`
          );
          break;
        case "getSMSConsumeAndBalance":
          response = await getAPI(DashboardEndpoint.getSMSConsumeAndBalance);
          break;
        case "getTodayLeadDetails":
          response = await getAPI(DashboardEndpoint.getTodayLeadDetails);
          break;
        case "getAllActiveStudent":
          response = await getAPI(DashboardEndpoint.getAllActiveStudent);
          break;
        case "getNewAdmissionAndDropOut":
          response = await getAPI(DashboardEndpoint.getNewAdmissionAndDropOut);
          break;
        case "getCertificateInfo":
          response = await getAPI(DashboardEndpoint.getCertificateInfo);
          break;
        case "netStudentVsReceipts":
          response = await getAPI(
            `${DashboardEndpoint.netStudentVsReceipts}/${dashboardData.months}`
          );
          break;
        case "feedbackList":
          response = await postAPI(
            DashboardEndpoint.feedback,
            dashboardData.franchiseeId
          );
          break;
        case "submitFeedback":
          response = await postAPI(
            DashboardEndpoint.submitFeedback,
            dashboardData.formValues
          );
          break;
      }
      return response;
    } catch (err) {
      return err;
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(dashboardAction.fulfilled, (state, action: any) => {
      state.dashboardResponse = action.payload;
    });
    builder.addCase(dashboardAction.rejected, (state, action) => {
      if (action.payload) {
        state.entity = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const dashboardReducer = dashboardSlice.reducer;
export default dashboardReducer;
